module.exports = __webpack_public_path__ + "img/notice_code_2.jpg";